import { render, staticRenderFns } from "./governmentSectorList.vue?vue&type=template&id=2c77b348&scoped=true&"
import script from "./governmentSectorList.vue?vue&type=script&lang=js&"
export * from "./governmentSectorList.vue?vue&type=script&lang=js&"
import style0 from "./governmentSectorList.vue?vue&type=style&index=0&id=2c77b348&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77b348",
  null
  
)

export default component.exports